/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list-group-item[_ngcontent-%COMP%]{cursor:pointer;transition:.3s}.list-group-item[_ngcontent-%COMP%]:hover{background-color:#f8f9fa}.list-group-item.active[_ngcontent-%COMP%]{background-color:#007bff;border-color:#007bff}.list-group-item[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:8px}.card[_ngcontent-%COMP%]{box-shadow:0 2px 4px rgba(0,0,0,.1)}.card-header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0}.tab-content[_ngcontent-%COMP%]{min-height:400px}\n/*# sourceMappingURL=configuracion.component.css.map*/"];
export { styles as styles };
